import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as LoginController from '../Controller/LoginController';
import * as StoreController from '../../Utility/Controller/StoreController';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp, setUserEntryType, setCrossPanelAccess } from '../Actions/LoginAction';
import { setCurrentStore, setStoresFetched, setStores } from '../../../Actions/StoreActions';
import Utility from '../../Utility/Utility';
import LoginUtility from '../Utility/LoginUtility'

const AnotherLoginUrl = (props) => {
	const { loaderStateTrue, loaderStateFalse, history, logOutApp, setToken, setUserCredentials, setUserEntryType, setCurrentStore, setStores, setStoresFetched, setCrossPanelAccess } = props;
	const [messageReceived, setMessageReceived] = useState(false);

	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data && event.data.type === 'AUTO_LOGIN_PAYLOAD') {
				setMessageReceived(true);
				loginSuccess(event.data.payload);
			}
		};

		window.addEventListener('message', handleMessage);

		// Signal to the opener that the listener is ready
		if (window.opener) {
			window.opener.postMessage({ type: 'AUTO_LOGIN_READY' }, '*');
		}

		// Timeout after 30 seconds if no message received
		const timeout = setTimeout(() => {
			if (!messageReceived) {
				history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/login`);
			}
		}, 3000);

		return () => {
			window.removeEventListener('message', handleMessage);
			clearTimeout(timeout);
		};
	}, []);

	const loginSuccess = async (loginDetails) => {
		try {
			const finalIdToken = loginDetails.token;
			const accessToken = loginDetails.accessToken;
			const refreshToken = loginDetails.refreshToken;
			const expiresIn = LoginUtility.getExpiryDetails(loginDetails.expiresIn);
			let userGroup = [];
			const organisationGroup = [];

			await setToken(finalIdToken, accessToken, expiresIn, refreshToken, userGroup, organisationGroup, '');
			loaderStateTrue();

			try {
				let filters = {};
				filters['filters'] = JSON.stringify({});
				const orgResponse = await LoginController.userOrganisationGet(filters);
				if (orgResponse.success && orgResponse.data?.UserOrgBranchRoleRelation) {
					userGroup = orgResponse.data.UserOrgBranchRoleRelation;
				}
				if (userGroup.length > 0) {
					setUserEntryType(userGroup[0]);
				}
				const hasPmsAccess = orgResponse.data?.app_accesses?.has_pms === true;
				setCrossPanelAccess(hasPmsAccess);
			} catch (orgError) {
				console.error('userOrganisationGet failed', orgError);
			}

			const userResponse = await LoginController.getCurrentUser();
			loaderStateFalse();

			if (userResponse.success) {
				const loginCredentials = userResponse.data;
				if (loginCredentials.user_details.user_type !== "app_admin") {
					await fetchStores(loginCredentials, userGroup[0]);
				}
				await setToken(finalIdToken, accessToken, expiresIn, refreshToken, userGroup, organisationGroup, '');
				setUserCredentials(loginCredentials);
				navigateAfterLogin(loginCredentials);
			} else {
				await logOutApp();
				history.push('/');
				Utility.toastNotifications(userResponse.message, "Error", "error");
			}
		} catch (e) {
			console.error('AnotherLoginUrl failed', e);
			loaderStateFalse();
			history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/login`);
		}
	}

	const fetchStores = async (loginCredentials, entryType) => {
		try {
			const stores = await StoreController.getStores();
			if (stores.success) {
				let currentStoreId = entryType?.branch_id != null
					? entryType.branch_id
					: localStorage.getItem('store_id');
				const roleName = loginCredentials?.user_details?.role_name || loginCredentials?.user_details?.user_type;
				if (roleName === "staff") {
					currentStoreId = loginCredentials?.user_details?.branch_id;
				}
				const store = stores.data.find(s => s.id == currentStoreId) || stores.data[0];
				setCurrentStore(store);
				setStores(stores.data);
				setStoresFetched(true);
				localStorage.setItem('store_id', store.id);
			}
		} catch (error) {
			console.error('fetchStores failed in AnotherLoginUrl', error);
		}
	}

	const roleWiseTabSelectedPermission = (roleWisePermission) => {
		const subEventToRouteMap = {
			"master_dashboard": "dashboard", "master_dashboard_v2": "dashboard/v2",
			"billing_counter_dashboard": "billing-counter-dashboard",
			"purchase_orders": "sales/purchase-orders", "invoices": "sales/invoices",
			"orders": "sales/orders", "digital_menu_orders": "sales/digital-menu-orders",
			"quotations": "sales/quotations", "transactions": "sales/transactions",
			"accounts": "business/accounts", "monthly_targets": "business/monthly-targets",
			"business_registers": "business/registers", "users": "user/user",
			"customers": "users/customers", "roles": "user/role", "suppliers": "supplier",
			"tax_codes": "tax-codes", "discount_codes": "tax-discount/discount-codes",
			"products": "stock/products", "categories": "category",
			"stock_transfer": "stock/transfer", "stock_return": "stock/return",
			"product_label": "stock/product-label", "add_on_groups": "stock/addon-groups",
			"bookings_and_events": "bookings/events", "calendar": "bookings/calendar",
			"download_reports": "reports/download", "best_seller_report": "reports/best-seller",
			"day_wise_sale_report": "reports/day-wise-sale", "category_report": "reports/category",
			"stock_quantity_alert": "reports/stock-alert", "store_stock_chart": "reports/store-stock-chart",
			"kitchen_display": "restaurant/kitchen-display", "waiter_display": "restaurant/waiter-display",
			"tables": "restaurant/tables", "restaurant_menu": "restaurant/menu",
			"notifications": "notification/list", "import_data": "import/data",
			"upload_users": "import/upload-update", "stores": "settings/stores",
			"payment_methods": "settings/payment-methods", "billing_counters": "settings/billing-counters",
			"email_settings": "settings/email", "sms_settings": "settings/sms",
			"sms_templates": "settings/sms-templates", "measurement_units": "settings/measurement-units",
			"variant_options": "settings/variant-options", "printers": "settings/printers",
			"kitchen_displays": "settings/kitchen-displays", "app_settings": "settings/app"
		};
		for (const key in roleWisePermission) {
			const module = roleWisePermission[key];
			if (Array.isArray(module.subeventKey)) {
				for (const sub of module.subeventKey) {
					if (sub.rules && sub.rules !== "") {
						return subEventToRouteMap[sub.eventKey] || sub.eventKey;
					}
				}
			}
			if (module.rules && module.rules !== "") {
				return subEventToRouteMap[module.eventKey] || module.eventKey;
			}
		}
		return null;
	}

	const navigateAfterLogin = (loginCredentials) => {
		const userType = loginCredentials.user_details.user_type;
		const isSubscribed = loginCredentials.user_details.is_subscribed;
		const lng = localStorage.getItem('i18nextLng');
		if (userType === "customer") {
			Utility.toastNotifications("Access denied", 'Error', 'error');
			logOutApp().then(() => props.history.push("/"));
		} else if (userType === "app_admin") {
			props.history.push(`/${lng}/home/organisation`);
		} else if (userType === "admin") {
			if (isSubscribed) {
				props.history.push(`/${lng}/user/user`);
			} else {
				props.history.push(`/${lng}/settings/stores`);
			}
		} else {
			let rolePermissions = loginCredentials.user_details?.role_permission;
			if (typeof rolePermissions === "string") {
				try { rolePermissions = JSON.parse(rolePermissions); } catch (e) { rolePermissions = []; }
			}
			const permissionHash = {};
			rolePermissions?.forEach((value) => { permissionHash[value.eventKey] = value; });
			localStorage.setItem('permission_hash', JSON.stringify(permissionHash));
			const firstPermissionRoute = roleWiseTabSelectedPermission(permissionHash);
			if (firstPermissionRoute) {
				props.history.push(`/${lng}/${firstPermissionRoute}`);
			} else {
				props.history.push(`/${lng}/user/user`);
			}
		}
	}


	return (
		<></>
	);
}


const mapStateToProps = (globalState) => {
	return {
		token: globalState.LoginReducer.token,
		userCredentials: globalState.LoginReducer.userCredentials
	};
}



export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, setUserEntryType, logOutApp, setCurrentStore, setStores, setStoresFetched, setCrossPanelAccess })(AnotherLoginUrl);


